<template>
  <div class="contaier">
    <div class="form-box relative">
      <!-- <div class="title xl:text-3xl md:text-2xl text-2xl font-semibold">
        {{ $t("home.form_title") }}
      </div> -->
      <div class="title lg:text-[32px] text-2xl md:pb-[30px] pb-[20px] font-semibold">立即登記 盡享駕駛樂趣</div>
      <p class="note text-10px pb-[10px]" id="myElement">
        {{ $t('home.mandatory') }}
      </p>
      <el-form :model="form" ref="formRef" :rules="formRules" label-width="80px" label-position="top">
        <el-row :gutter="20">
          <el-col :md="24" :sm="24">
            <el-form-item :label="$t('home.contract')" prop="contract">
              <el-input
                v-model="form.contract"
                :placeholder="$t('home.rightContract')"
                class="tracking-[0.5px]"
                maxlength="8"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :md="4" :sm="6" :xs="8">
            <el-form-item :label="$t('home.appellation')" prop="title">
              <el-select
                style="width: 100%"
                :value="form.title"
                @change="changeTitle"
                :placeholder="$t('home.selectAppellation')"
              >
                <el-option :label="$t('appellation.Sir')" :value="$t('appellation.Sir')"></el-option>
                <el-option :label="$t('appellation.lady')" :value="$t('appellation.lady')"></el-option>
                <el-option :label="$t('appellation.Miss')" :value="$t('appellation.Miss')"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="10" :sm="18" :xs="16">
            <el-form-item :label="$t('home.lastName')" prop="lastName">
              <el-input v-model="form.lastName" :placeholder="$t('home.enterLastName')" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="10" :sm="24">
            <el-form-item :label="$t('home.firstName')" prop="firstName">
              <el-input v-model="form.firstName" :placeholder="$t('home.enterFirstName')" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.mobileNumber')" prop="phone">
              <div class="phone-box">
                <div class="phone-sum">+852</div>
                <div class="phone-">
                  <el-input v-model="form.phone" :placeholder="$t('home.enterPhone')" maxlength="10"></el-input>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.emailAddress')" prop="email">
              <el-input v-model="form.email" :placeholder="$t('home.enterEmail')" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- class="hidden-xs-only" -->
        <el-row :gutter="20">
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('carOption.cartitle')" prop="carModel">
              <el-select
                style="width: 100%"
                :value="form.carModel"
                @change="changeCar"
                :placeholder="$t('carOption.carModel_')"
              >
                <el-option label="V23 (RWD)" value="V23 (RWD)"></el-option>
                <el-option label="V23 Sport (AWD)" value="V23 Sport (AWD)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <!-- <el-form-item :label="$t('home.selectLanguage')" prop="language">
              <el-select style="width: 100%" :value="form.language" @change="changeLan"
                :placeholder="$t('home.pleaseSelectLanguage')">
                <el-option :label="$t('home.lang_en')" :value="$t('home.lang_en')"></el-option>
                <el-option :label="$t('home.lang_cn')" :value="$t('home.lang_cn')"></el-option>
              </el-select>
            </el-form-item> -->
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :md="12" :sm="12">
            <el-form-item class="relative" :label="$t('dateTime.dateTitle')" prop="date">
              <el-date-picker
                style="width: 100%"
                @focus="hideFullAdjacentRows"
                v-model="selectedDate"
                type="date"
                :placeholder="$t('dateTime.date_')"
                ref="datePicker"
                format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                popper-class="hide-adjacent-months"
                @change="changeDate"
              />
              <div class="text-[11.5px] sm:text-[13px] absolute top-0 right-[38px] text-[#606266] pointer-events-none">
                {{ dateText }}
              </div>
              <!-- <el-select style="width: 100%" :value="form.carModel" @change="changeCar"
                :placeholder="$t('carOption.date_')">
                <el-option label="V23 (RWD)" value="V23 (RWD)"></el-option>
                <el-option label="V23 Sport (AWD)" value="V23 Sport (AWD)"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('dateTime.timePeriodTitle')" prop="timePeriod">
              <el-select
                style="width: 100%"
                :value="form.timePeriod"
                :placeholder="$t('dateTime.timePeriod_')"
                @change="changeTime"
                @focus="changeTimeVer"
                :no-data-text="noDataText"
              >
                <template slot="prefix">
                  <i class="el-icon-time"></i>
                </template>
                <el-option
                  v-for="(item, index) in timePeriodList"
                  :label="item.value"
                  :value="item.value"
                  :key="index"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item :label="$t('home.corporateClient')" prop="enterprise">
          <el-radio-group v-model="form.enterprise">
            <el-radio :label="$t('home.yes')"></el-radio>
            <el-radio :label="$t('home.no')"></el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item
          :label="$t('home.corporateClient')"
          prop="enterprise"
          class="hidden-sm-and-up"
        >
          <el-radio-group v-model="form.enterprise">
            <el-radio :label="$t('home.yes')"></el-radio>
            <el-radio :label="$t('home.no')"></el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item
          v-if="form.enterprise === '是' || form.enterprise === 'Yes'"
          :label="$t('home.pleaseWriteName_')"
          prop="enterpriseUser"
          :rules="[
            {
              required: form.enterprise == '是' || form.enterprise === 'Yes',
              message: $t('home.pleaseWriteName'),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.enterpriseUser"
            :placeholder="$t('home.pleaseWriteName')"
          ></el-input>
        </el-form-item> -->

        <!-- <el-form-item :label="$t('home.remark')">
          <el-input v-model="form.remark"></el-input>
        </el-form-item> -->
        <el-form-item prop="agreePrivacy">
          <el-checkbox-group style="width: 100%" v-model="form.agreePrivacy">
            <el-checkbox name="agreePrivacy" :label="true">
              {{ $t('home.agree_') }}
              <a class="to-page" @click="centerDialogRR = true">{{ $t('home.rentCar_') }}</a>
              、
              <a class="to-page" @click="goNewPage">{{ $t('home.policy_') }}</a>
              {{ $t('home.and') }}
              <a class="to-page" @click="goNewPage1">{{ $t('home.statement_') }}</a>
              {{ $t('home.fullStop') }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item>
          <el-checkbox-group style="width: 100%" v-model="form.agreeUsePersonal">
            <el-checkbox name="agreeUsePersonal" :label="true">{{ $t('home.privacyPolicy') }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <div class="btn bg-[#f48e30] text-[#000] font-bold" @click="submitForm">{{ $t('home.submit') }}</div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" top="40vh" width="320px" center>
      <div class="mt-[-26px]">
        <h3 class="text-[22px] text-[#000] text-center font-bold mb-2">提示</h3>
        <p class="text-[18px] text-[#111] text-center">該時間段名額已滿，請重新選擇</p>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="centerDialogRR" custom-class="w-[96%]  sm:w-[80%] mdd:w-[70%]">
      <h2 class="text-center text-[26px] text-black mb-10 mt-[-20px] font-bold">租車條及與細則</h2>
      <RentReg class="bg-white"></RentReg>
    </el-dialog>

    <el-dialog
      class="cLoading"
      top="35vh"
      width="190px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible2"
    >
      <div class="dialog-box dialog-box2">
        <i class="el-icon-loading icon-check"></i>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { addIcaurRentCarApi, timePeriodListApi } from '@/Api/requestApi'
import RentReg from '@/components/RentReg.vue'

import moment from 'moment'

export default {
  name: 'FormPage',
  components: {
    RentReg,
  },
  data() {
    let validateContract = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.rightContract')))
      }
      if (!/^I/.test(value)) {
        return callback(new Error(this.$t('home.contractStartWithI')))
      }
      if (value.length < 5 || value.length > 8) {
        return callback(new Error(this.$t('home.contractLength')))
      }
      callback()
    }
    let validateTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.selectAppellation')))
      }
      callback()
    }
    let enterLastName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterLastName')))
      }
      callback()
    }
    let enterFirstName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterFirstName')))
      }
      callback()
    }
    // let pleaseSelectLanguage = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t("home.pleaseSelectLanguage")));
    //   }
    //   callback();
    // };

    // let Postcode = (postcode) => {
    //   const regex = /^[0-9][0-9]{5}$/;
    //   return valid(postcode, regex, "請輸入正確的郵箱！");
    // };
    let Postcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterEmail')))
      }
      const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!regExp.test(value)) {
        return callback(new Error(this.$t('home.rightEmail')))
      } else {
        callback()
      }
    }
    let phonecode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterPhone')))
      }
      const regExp = /^(4|5|6|7|8|9)\d{7}$/
      if (!regExp.test(value)) {
        return callback(new Error(this.$t('home.rightPhone')))
      } else {
        callback()
      }
    }

    let carModelCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('carOption.carModel_')))
      }
      callback()
      // const regExp = /^(4|5|6|8|9)\d{7}$/;
      // if (!regExp.test(value)) {
      //   return callback(new Error(this.$t("home.rightPhone")));
      // } else {
      //   callback();
      // }
    }

    let dateCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('dateTime.date_')))
      }
      callback()
    }

    let timePeriodCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('dateTime.timePeriod_')))
      }
      callback()
    }

    // let corporateClient_ = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t("home.corporateClient_")));
    //   }
    //   callback();
    // };

    let _policy = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error(this.$t('home._policy')))
      }
      callback()
    }

    return {
      centerDialogRR: false,
      dialogVisible: false,
      dialogVisible2: false,
      // dialogVisible1: false,
      noDataText: '暫無日期可選',
      timePeriodList: [],
      timePeriodList1: [
        //   { value: '09:00 - 12:00' },
        //   { value: '12:30 - 15:30' },
        //   { value: '16:00 - 19:00' }
      ],
      timePeriodList2: [
        //   { value: '09:00 - 10:00' },
        //   { value: '10:15 - 11:15' },
        //   { value: '11:30 - 12:30' },
        //   { value: '12:45 - 13:45' },
        //   { value: '14:00 - 15:00' },
        //   { value: '15:15 - 16:15' },
        //   { value: '16:30 - 17:30' },
        //   { value: '17:45 - 18:45' }
      ],
      dateText: '',
      selectedDate: '',
      // 禁用日期列表（可定义在 data 中以便动态修改）
      disabledPublicHoliday: [
        '2026/04/03',
        '2026/04/04',
        '2026/04/06',
        '2026/04/07',
        '2026/05/01',
        '2026/05/25',
        '2026/06/19',
        '2026/07/01',
        '2026/09/26',
        '2026/10/01',
        '2026/10/19',
        '2026/12/25',
        '2026/12/26',
      ],
      disabledWeekend: [],
      pickerOptions: {
        // 使用箭头函数确保 this 指向正确
        disabledDate: (time) => {
          // 1. 只允许 2026 年 4 月或 5 月
          const year = time.getFullYear()
          const month = time.getMonth() + 1
          const isAllowedMonth = year === 2026 && (month === 11 || month === 12)

          if (!isAllowedMonth) {
            return true // 不在允许的月份范围内，禁用
          }

          // 2. 禁止选择小于当前日期的日期（今天之前的日期）
          const today = moment().startOf('day') // 今天 00:00:00
          const pickDate = moment(time).startOf('day')
          if (pickDate.isBefore(today)) {
            // 小于，禁用
            return true
          }
          // isSameOrBefore // 小于及今天，禁用

          // 3. 排除 disabledPublicHoliday 中的具体日期
          // const dateStr = moment(time).format('YYYY/MM/DD')
          // if (this.curDisabledAll.includes(dateStr)) {
          //   return true  // 在禁用列表中，禁用
          // }

          // 所有条件都通过，该日期可选
          return false
        },
      },
      form: {
        contract: '',
        title: '',
        lastName: '',
        firstName: '',
        phone: '',
        email: '',
        carModel: '',
        // remark: "",
        // language: this.$i18n.locale === "zh" ? "英文" : "English",
        date: '',
        timePeriod: '',
        // enterprise: "", //我加的
        // enterpriseUser: "",
        // carReplace: "",
        agreePrivacy: [],
        agreeUsePersonal: [],
      },

      formRules: {
        contract: [{ required: true, validator: validateContract, trigger: 'blur' }],
        title: [{ required: true, validator: validateTitle, trigger: 'change' }],
        lastName: [{ required: true, validator: enterLastName, trigger: 'blur' }],
        firstName: [{ required: true, validator: enterFirstName, trigger: 'blur' }],
        // language: [
        //   {
        //     required: true,
        //     validator: pleaseSelectLanguage,
        //     trigger: "change",
        //   },
        // ],
        phone: [{ required: true, validator: phonecode, trigger: 'change' }],
        email: [{ required: true, validator: Postcode, trigger: 'change' }],
        carModel: [{ required: true, validator: carModelCode, trigger: 'change' }],
        date: [{ required: true, validator: dateCode, trigger: 'change' }],
        timePeriod: [{ required: true, validator: timePeriodCode, trigger: 'change' }],

        // enterprise: [{ required: true, validator: corporateClient_, trigger: "blur" }],

        agreePrivacy: [
          {
            type: 'array',
            // required: true,
            validator: _policy,
            trigger: 'change',
          },
        ],
      },

      unwatchPickerDate: null,
    }
  },
  beforeDestroy() {
    // 组件销毁前，务必移除监听
    if (this.unwatchPickerDate) {
      this.unwatchPickerDate()
      this.unwatchPickerDate = null
    }
  },
  computed: {
    curDisabledAll() {
      console.log('合集禁止', [...this.disabledPublicHoliday, ...this.disabledWeekend])
      return [...this.disabledPublicHoliday, ...this.disabledWeekend]
    },
  },
  mounted() {
    this.$nextTick(() => {
      const datePicker = this.$refs.datePicker
      if (!datePicker) return

      // 监听日历面板是否打开
      datePicker.$watch('pickerVisible', (isVisible) => {
        if (isVisible) {
          // 面板打开：获取内部picker组件，监听其date数据
          const picker = datePicker.picker
          if (picker && !this.unwatchPickerDate) {
            this.unwatchPickerDate = picker.$watch('date', (newDate) => {
              // 面板内部的年月数据发生变化，即发生了月份/年份切换
              console.log('切换后的面板当前日期：', newDate)
              // 在这里调用你的方法，比如根据 newDate 获取当月数据
              this.fetchData(newDate)
            })
          }
        } else {
          // 面板关闭：清理监听器，防止内存泄露
          if (this.unwatchPickerDate) {
            this.unwatchPickerDate()
            this.unwatchPickerDate = null
          }
        }
      })
    })
  },
  methods: {
    getWeekendsInMonth(year, month) {
      // month 参数：0-11（0 代表一月），若传入 1-12 可自行调整
      const startDate = moment(`${year}-${month}-01`, 'YYYY-MM-DD')
      const endDate = startDate.clone().endOf('month')
      const weekends = []
      console.log('year, month', year, month)
      let current = startDate.clone()
      while (current.isSameOrBefore(endDate)) {
        const dayOfWeek = current.day() // 0=周日, 6=周六
        if (dayOfWeek === 0 || dayOfWeek === 6) {
          weekends.push(current.format('YYYY/MM/DD'))
        }
        current.add(1, 'day')
      }
      return weekends
    },
    fetchData(currentDate) {
      console.log('当前月份', moment(currentDate).format('YYYY-MM'))
      this.disabledWeekend = []
      this.hideFullAdjacentRows()
      // // 禁止当天 要N+1
      // this.disabledWeekend.push(moment().format('YYYY/MM/DD'))
      this.disabledWeekend = this.getWeekendsInMonth(
        Number(moment(currentDate).format('YYYY')),
        Number(moment(currentDate).format('M'))
      )
      console.log('curDisabledAll', this.curDisabledAll)
    },
    hideFullAdjacentRows() {
      document.querySelectorAll('.el-date-table__row').forEach((row) => {
        const cells = row.querySelectorAll('td')
        if (cells.length !== 7) return
        const allPrevOrNext = Array.from(cells).every(
          (td) => td.classList.contains('prev-month') || td.classList.contains('next-month')
        )
        row.style.display = allPrevOrNext ? 'none' : ''
      })
    },
    async handleDateChange(date, carModel) {
      // console.log('eeeeeeeeeeeeeee', e, this.curDisabledAll.includes(moment(e).format('YYYY/MM/DD')))
      this.timePeriodList = []
      this.form.timePeriod = ''
      this.dateText = ''
      this.noDataText = '載入中...'
      //console.log('moment', moment(date).format('YYYY/MM/DD'), date, carModel)
      // code: noDataTextCode,
      const { timePeriodList1, timePeriodList2 } = await this.getTimePeriod({ date, carModel })

      console.log('timePeriodList1, timePeriodList2', timePeriodList1, timePeriodList2)
      // if (noDataTextCode == 200) this.noDataText = "暫無日期可選"

      if (this.curDisabledAll.includes(moment(date).format('YYYY/MM/DD'))) {
        this.timePeriodList = timePeriodList2
        this.dateText = ' (周末及公衆假期：$35/小時)'
      } else if (date != null) {
        this.timePeriodList = timePeriodList1
        this.dateText = ' (平日：$90/3小時)'
      }
      if (this.timePeriodList.length == 0) this.noDataText = '暫無日期可選'

      console.log('e', this.form.date)
      console.log('e', this.timePeriodList)
    },
    submitForm() {
      // this.dialogVisible = true;
      // this.dialogVisible2 = true;
      // let _lang = window.sessionStorage.getItem("sessionLang") || "zh";
      // this.$router.push({ path: "/succeed", query: { lang: _lang } });
      // this.$router.push({ path: "/succeed" });
      // return;
      this.$refs.formRef.validate(async (valid) => {
        // console.log("valid :>> ", valid);
        if (valid) {
          let formDate_ = cloneDeep(this.form)

          formDate_.phone = `852 ${formDate_.phone}`

          // console.log("form :>>通过了 11", this.form);
          // return;

          formDate_.agreePrivacy = formDate_.agreePrivacy[0]
          formDate_.agreeUsePersonal = formDate_.agreeUsePersonal[0]
          // delete formDate_.enterprise;
          // formDate_.agreePrivacy = formDate_.agreePrivacy.join("");
          // formDate_.agreeUsePersonal = formDate_.agreeUsePersonal.join("");

          console.log('form :>>通过了 ', formDate_)
          this.dialogVisible2 = true
          // return;
          const {
            data: { code },
          } = await addIcaurRentCarApi(formDate_)

          if (code === 200) {
            // this.dialogVisible = true;
            this.form = {
              contract: '',
              title: '',
              lastName: '',
              firstName: '',
              phone: '',
              email: '',
              // remark: "",
              // language: this.$i18n.locale === "zh" ? "英文" : "English",
              carModel: '',
              date: '',
              timePeriod: '',
              // enterpriseUser: "",
              // carReplace: "",
              agreePrivacy: [],
              agreeUsePersonal: [],
            }
            this.$refs.formRef.resetFields()
            setTimeout(() => {
              // this.dialogVisible = false;
              this.dialogVisible2 = false
              this.$router.push({ path: '/succeed' })
              // this.$router.push({ path: "/succeed", query: { lang: _lang } });
            }, 1000)
          } else if (code === 400) {
            if (this.form.carModel && this.form.date) this.handleDateChange(this.form.date, this.form.carModel)
            setTimeout(() => {
              this.dialogVisible2 = false
              this.dialogVisible = true
            }, 500)
          }
        } else {
          document.getElementById('myElement')?.scrollIntoView()
          return false
        }
      })
    },
    async getTimePeriod(e) {
      const {
        data: {
          code,
          data: { timePeriodList1, timePeriodList2 },
        },
      } = await timePeriodListApi(e)
      // console.log(code, timePeriodList1, timePeriodList2)
      return { code, timePeriodList1, timePeriodList2 }
    },
    resetForm() {
      this.$refs.formRef.resetFields()
    },
    goNewPage() {
      window.open('https://www.kamlung.com/privacy-policy?lang=tc', '_blank')
    },
    goNewPage1() {
      window.open('https://www.kamlung.com/copy-of-privacy-policy?lang=tc', '_blank')
    },
    // _______________________
    // openForm() {
    //   this.dialogVisible = true;
    // },
    // openForm2() {
    //   this.dialogVisible1 = true;
    // },
    // ---------------------------
    downloadPDF() {
      const link = document.createElement('a')
      link.href = 'https://ssy.kamlung.net/excel/pv5.pdf'
      link.download = 'filename.pdf'
      link.target = '_blank'
      link.click()
      // document.body.removeChild(link);
    },
    changeLanguage(e) {
      // console.log("validateTitle :>> ", validateTitle);
      this.$refs.formRef.resetFields()

      if (e === 'en') {
        console.log('e :>>2211 ', e)
        this.form.language = this.form.language === '繁體中文' ? '繁體中文' : '英文'
      } else {
        console.log('e :>>2222 ', e)
        // console.log("999999999 ", this.form.language);
        this.form.language = this.form.language === '繁體中文' ? 'Chinese' : 'English'
      }
      // this.$refs.formRef.validate((valid) => {
      //   console.log("没通过 :>>1 ");
      //   if (!valid) {
      //     console.log("没通过 :>>2 ");
      //   }
      // });
    },
    changeTitle(v) {
      console.log('v :>>changeTitle ', v)
      this.form.title = v
    },
    changeCar(v) {
      console.log('v :>>changeTitle ', v)
      this.form.carModel = v

      if (this.form.carModel && this.form.date) this.handleDateChange(this.form.date, this.form.carModel)
    },
    changeLan(v) {
      console.log('v :>>changeTitle ', v)
      this.form.language = v
    },
    changeTime(v) {
      console.log('v :>>changeTitle ', v)
      this.form.timePeriod = v
    },
    changeDate(v) {
      console.log('v :>>changeTitle ', moment(v).format('YYYY-MM-DD'))
      this.form.date = moment(v).format('YYYY-MM-DD')
      console.log('changeDatechangeDatechangeDate', this.form.carModel, this.form.date, this.selectedDate)

      if (isNaN(new Date(this.form.date).getTime())) {
        this.form.date = ''
        this.timePeriodList = []
        this.form.timePeriod = ''
        this.dateText = ''
        this.noDataText = '暫無日期可選'
      }

      if (this.form.carModel && this.form.date) this.handleDateChange(this.form.date, this.form.carModel)
    },
    changeTimeVer() {
      if (!this.form.carModel || !this.form.date) {
        this.$message({
          showClose: true,
          message: '請先 選擇車型 和 選擇日期',
          type: 'warning',
        })
      }
    },
  },
}
</script>

<style lang="scss">
/* 使用 :deep 或全局样式穿透 */
.hide-adjacent-months .next-month,
.hide-adjacent-months .prev-month {
  visibility: hidden;
}

// .el-select-dropdown__item.selected {
//   color: #d97316;
// }

// .el-month-table td.disabled:hover .cell {
//   color: #C0C4CC;
// }

// .el-month-table td:hover .cell {
//   color: #d97316;
// }

// .el-month-table td.today .cell {
//   color: #d97316;
// }

// .el-date-picker__header-label:hover {
//   color: #d97316;
// }

// .el-date-table td.disabled:hover span {
//   color: #C0C4CC;
// }

// .el-date-table td:hover span {
//   color: #d97316;
// }

// .el-date-table td.today span {
//   color: #d97316;
// }

// .el-date-table td.current:not(.disabled) span {
//   background: #d97316;
// }

.row-expand-cover td .el-table__expand-icon {
  visibility: hidden;
}

.custom-class-dialog1 {
  background-color: #f56c6c;

  .el-dialog__body {
    padding: 22px 15px 48px 15px !important;
  }
}

input[aria-hidden='true'] {
  display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}
</style>

<style lang="scss" scoped>
@import 'element-ui/lib/theme-chalk/display.css';

.el-form-item {
  margin-bottom: 26px !important;
}

@media (min-width: 400px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1024px) {
}

@media (max-width: 768px) {
  /* 平板样式 */
}

@media (max-width: 1024px) {
  /* 桌面样式 */
}

@media (max-width: 470px) {
  .img-bg {
    aspect-ratio: 3 / 9;
  }
}

@media (max-width: 440px) {
  .img-bg {
    aspect-ratio: 3 / 10;
  }
}

@media (max-width: 390px) {
  .img-bg {
    aspect-ratio: 3 / 12;
  }
}

.contaier {
  padding: 60px 0;
  background-color: #fff;

  ::v-deep .cLoading .el-dialog {
    border-radius: 10px !important;
    background: none !important;
    background-color: rgba(000, 000, 000, 0.6) !important;
  }

  [aria-hidden='true'] {
    display: none !important;
  }

  .form-box {
    // padding: 30px;
    // border-radius: 5px;
    .title {
      font-family: 'icaurFontBold', sans-serif;
    }

    width: 92%;
    margin: 0 auto;
    max-width: 1200px;

    .phone-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .phone-sum {
        width: 66px;
        // padding-top: 10px;
        font-size: 1.1rem !important;
        // line-height: 1.2rem !important;
        font-weight: 400;
      }

      .phone- {
        flex: 1;
      }
    }

    .note {
      color: #999;
    }

    .note:before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }

    ::v-deep .el-input {
      font-size: 1.05rem !important;
    }

    ::v-deep .el-form-item__label {
      font-size: 1.15rem !important;
      line-height: 1.6rem !important;
      font-weight: 400;
    }

    ::v-deep .el-radio__label {
      font-size: 1.15rem !important;
      // line-height: 1.2rem !important;
      font-weight: 400;
    }

    ::v-deep .el-radio {
      // margin-right: 72px !important ;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-right: 30px !important;
    }

    ::v-deep .el-radio__inner {
      border-color: #000 !important;
      transform: scale(1.5);
    }

    ::v-deep .el-radio-group {
      padding-left: 4px !important;
    }

    ::v-deep .el-checkbox__inner {
      border-color: #000 !important;
      // background-color: #000 !important ;
      transform: scale(1.5);
      // width: 22px !important;
      // height: 22px !important;
    }

    ::v-deep .el-checkbox__label {
      font-size: 1.05rem !important;
      line-height: 1.6rem !important;
      padding-left: 15px !important;
      white-space: pre-wrap;
      color: #000;
      // line-height
      font-weight: 400;
    }

    ::v-deep .el-checkbox-group {
      padding-left: 4px !important;
    }

    ::v-deep .el-radio__input.is-checked + .el-radio__label {
      color: #000 !important;
    }

    ::v-deep .el-radio__input.is-checked .el-radio__inner {
      background: #000 !important;
    }

    ::v-deep .is-checked .el-checkbox__inner {
      background-color: #000 !important;
      // border-color: #409EFF;
    }

    .checkbox-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .checkbox- {
        width: 20px;
      }

      .text {
        padding-left: 10px;
        flex: 1;
        font-size: 1.1rem !important;
        line-height: 1.8rem !important;
        font-weight: 400;
      }
    }

    .to-page {
      cursor: pointer;
      text-decoration: underline;
    }

    ::v-deep .el-input__inner {
      border: none !important;
      border-radius: 0 !important;
      border-bottom: #666 1px solid !important;
    }

    // ::v-deep .el-textarea__inner {
    //   border: none !important;
    //   border-radius: 0 !important;
    //   border-bottom: #666 1px solid !important;
    // }

    ::v-deep .is-error .el-input__inner {
      border-bottom: #f56c6c 2px solid !important;
    }

    .el-checkbox {
      display: flex !important;
      // justify-content: space-between;
      align-items: center;
    }
  }

  .btn-box {
    padding-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;

    .btn {
      width: 200px;
      line-height: 40px;
      border-radius: 20px;
      cursor: pointer;
    }
  }
}

::v-deep.el-select-dropdown__item {
  font-size: 1.1rem !important;
  // line-height: 1.2rem !important;
  font-weight: 400;
}

.dialog-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .icon-check {
    font-size: 60px;
    font-weight: 600;
    color: #fff;
  }

  .title {
    padding-top: 10px;
    font-size: 16px;
    color: #fff;
  }
}

.dialog-box2 {
  padding-top: 5px;
  padding-bottom: 30px;
}

.dialog-box1 {
  .iframe {
    // white: 100%;
  }
}
</style>
